import { compareAddresses } from '@onbeam/utils';
import { type Translate } from 'next-translate';
import { Address, isAddress } from 'viem';
import { z } from 'zod';

export const transferValidationSchema = (
  t: Translate,
  userAddress?: string,
  ownedQuantity?: number,
) =>
  z.object({
    address: z
      .custom<Address>(isAddress, {
        message: t('transfer-modal.initial.fields.address.errors.invalid'),
      })
      .refine(value => !compareAddresses(value, userAddress), {
        message: t('transfer-modal.initial.fields.address.errors.self'),
      }),
    quantity: z
      .number()
      .min(1, { message: t('transfer-modal.initial.fields.quantity.errors.min') })
      .max(ownedQuantity || Infinity, {
        message: t('transfer-modal.initial.fields.quantity.errors.max'),
      }),
  });
